import { Typography } from '@cobliteam/ui/components';

import insightsLogo from '../../resources/insightsLogo.webp';

const LandingContent = () => {
  return (
    <div className='mt-14 flex flex-col gap-8'>
      <div className='flex flex-col items-center justify-center gap-3'>
        <div>
          <img src={insightsLogo} className='size-16' />
        </div>
        <Typography variant='heading-2xl' className='font-bold' as='h1'>
          Insights Cobli IA
        </Typography>
        <Typography className='self-stretch' variant='body' color='secondary'>
          Os insights gerados pela inteligência artificial da Cobli utilizam os dados relativos ao desempenho da sua frota para notificar sobre aspectos relevantes que merecem
          receber a sua atenção.
        </Typography>
        <br />
        <Typography className='self-stretch' variant='body' color='secondary'>
          Cinco insights serão gerados semanalmente sobre assuntos relativos à semana anterior. Você pode conferir os insights na página inicial do seu painel ou na seção dedicada
          à inteligência artificial da Cobli na barra de navegação superior.
        </Typography>
        <br />
        <Typography className='self-stretch' variant='body' color='secondary'>
          Clique nos insights ao lado esquerdo para conferir insights novos e passados.
        </Typography>
      </div>
    </div>
  );
};

export default LandingContent;
